import { createInstance, dateReviver } from '@/api';
import { DeliveryRunClient } from '@/api';
import { i18n } from '@/i18n';
import { useAlertStore } from '@/modules/core/store/alert.store';
import { defineStore } from 'pinia';

export interface DeliveryRunStoreState {
    loading: boolean;
    reloading: boolean;
}

export const client = new DeliveryRunClient('', createInstance(), dateReviver);

export const useDeliveryRunStore = defineStore('configuration-delivery-run-store', {
    state: (): DeliveryRunStoreState => ({
        loading: false,
        reloading: false
    }),
    actions: {
        async startdryrun(definitionId: number, includeProductProcessDefinitions: boolean, importData: boolean, includeTriggeredDeliveryDefinitions: boolean) {
            this.reloading = true;

            try {
                await client.createDryRun(definitionId, includeProductProcessDefinitions, importData, includeTriggeredDeliveryDefinitions);
                useAlertStore().setSuccess(i18n.global.t('deliveryprocessdefinition.detail.success.dryrun.title'));
            } catch (error) {
                useAlertStore().handleException(
                    i18n.global.t('deliveryprocessdefinition.detail.error.dryrun.title'),
                    error,
                    false
                );
                return null;
            } finally {
                this.reloading = false;
            }
        }
    }
});
